import React, { FunctionComponent, useState } from "react";

import { bemClassNames } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";
import { Icon, IconColor } from "../Icon";
import { JustifyContent, Layout } from "../Layout";
import { AlignItems, FormComponentEventHandlersProps, FormComponentProps } from "../types";
import { generateFormComponentClasses } from "../utils";

export type IconEditComponentProps = {
    /** Kód určující, která ikona se zobrazí */
    iconCode?: IconCode;
    /** Velikost ikony */
    iconSize?: number;
} & FormComponentProps & FormComponentEventHandlersProps;

const classNames = bemClassNames("icon-edit-component");

export const IconEditComponent: FunctionComponent<IconEditComponentProps> = ({
    iconCode,
    iconSize,
    disabled,
    encrypted,
    invalid,
    required,
    backgroundColor,
    readOnly,
    onBlur,
    onFocus,
    ...restProps
}) => {
    const [focused, setFocus] = useState<boolean>(false);

    const classes = generateFormComponentClasses(classNames, {
        disabled,
        encrypted,
        invalid,
        required,
        backgroundColor,
        readOnly,
    }, [classNames({ focused })]);

    return (
        <div className={classes}>
            <button
                aria-disabled={disabled}
                onFocus={(e) => {
                    if (!disabled) setFocus(true);
                    onFocus && onFocus(e);
                }}
                onBlur={(e) => {
                    if (!disabled) setFocus(false);
                    onBlur && onBlur(e);
                }}
                {...restProps}>
                <Layout justifyContent={JustifyContent.center} alignItems={AlignItems.center}>
                    {iconCode &&
                    <Icon color={IconColor.inherit} {...{ iconCode, size:iconSize }} />
                    }
                </Layout>
            </button>
        </div>
    );
};
